import { Box, TextField, Typography } from "@mui/material";
import { useState } from "react";
import useSmartAndRegularAssets from "../../../../../api/hooks/useSmartAndRegularAssets";
import LoadingIcon from "../../../../../components/LoadingIcon";

import useColors from "../../../../../api/hooks/useColors";
import { AssetClass } from "../../../../../utils/constants";

function isAssetNameAlreadyInUse(allAssets, currentOriginalName, name) {
  let alreadyInUse = false;
  allAssets?.forEach((asset) => {
    if (asset.name === name && asset.name !== currentOriginalName)
      alreadyInUse = true;
  });
  return alreadyInUse;
}

function isNameValid(allAssets, currentOriginalName, name) {
  // Name is not made of only spaces, not used by other asset and not empty
  return (
    !/^\s+$/.test(name) &&
    !isAssetNameAlreadyInUse(allAssets, currentOriginalName, name) &&
    !(name === "")
  );
}

const AssetNameInput = ({
  formData,
  setFormData,
  assetToEdit = null,
  setIsValidName = null,
}) => {
  const [newAssetName, setNewAssetName] = useState(
    formData.stepAssetDetails.asset.assetName
  );
  const colors = useColors();
  const originalAssetName = assetToEdit?.asset?.name;
  const disabled = assetToEdit?.asset?.cls === AssetClass.SMART;
  // Fetch all assets to check if the name is already in use or not
  const { isLoadingAll: assetsAreLoading, regularAndActiveSmartAsset: assets } =
    useSmartAndRegularAssets(false);
  const handleOnChange = (value) => {
    setNewAssetName(value);
    let isAssetNameValid = isNameValid(assets, originalAssetName, value);
    if (setIsValidName) setIsValidName(isAssetNameValid);

    if (!isAssetNameValid) {
      setFormData((prevData) => ({
        ...prevData,
        stepAssetDetails: {
          asset: {
            ...prevData.stepAssetDetails.asset,
            assetName: "",
          },
        },
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        stepAssetDetails: {
          asset: {
            ...prevData.stepAssetDetails.asset,
            assetName: value,
          },
        },
      }));
    }
  };

  return assetsAreLoading ? (
    <LoadingIcon />
  ) : (
    <>
      <TextField
        placeholder="Asset Name"
        fullWidth
        label={
          <Box display={"flex"} flexDirection={"row"} gap={1}>
            <Typography variant="body2" color={colors.text_secondary}>
              Asset Name
            </Typography>
            <span style={{ color: colors.error_main }}>*</span>
          </Box>
        }
        variant="outlined"
        type="text"
        value={newAssetName}
        onChange={(event) => handleOnChange(event.target.value)}
        error={isAssetNameAlreadyInUse(assets, originalAssetName, newAssetName)}
        helperText={
          isAssetNameAlreadyInUse(assets, originalAssetName, newAssetName)
            ? "Name is already in use. Please enter a different name. "
            : ""
        }
        disabled={disabled}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "8px",
            borderColor: colors.divider2,
          },
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "0.5px solid " + colors.divider2,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: "0.5px solid " + colors.grey_500,
            },
          },

          "& .MuiInputBase-input::placeholder": {
            color: colors.text_primary,
          },
          width: "100%",
          "& .MuiInputBase-root": { height: "52px", fontSize: "14px" },
        }}
      />
    </>
  );
};

export default AssetNameInput;
